import { tags } from '../tagNames';
import { useUserTags } from '../useUserTags';

export const useIsIncreasedSextingCost = () => {
	const { userTags } = useUserTags();

	return userTags.includes(tags.sextingCostIncrease);
};
